import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Currency from 'components/consumer/Currency';
import IconCheck from 'components/icons/iconCheck';
import IconFourSquare from 'components/icons/iconFourSquare';
import JBImage from 'components/essentials/JBImage';
import Link from 'components/consumer/Link';
import isExternalLink from 'commons/isExternalLink';
import getSofaBuilderLink from 'commons/getSofaBuilderLink';

const PDPAvailableInSizesListItem = ({
  byoCollectionName,
  dimensions,
  id,
  image,
  isActive,
  isBYO = false,
  name,
  price,
  urlKey,
  productsData = [],
}) => {
  const linkTo = {
    // If the urlKey includes a query string, pass the pathname and search
    // properties separately into the Link component
    ...(urlKey?.includes('?')
      ? {
          pathname: urlKey.split('?')[0],
          search: urlKey.split('?')[1],
        }
      : {
          pathname: urlKey,
        }),
    state: {
      resetState: false,
      scrollToTop: false,
      productId: isBYO ? undefined : id,
      source: 'PDPAvailableInSizesRowUI',
      initialIsExpanded: true,
      productsData,
    },
  };

  return (
    <Link
      to={linkTo}
      className="text-gray !no-underline !hover:no-underline"
      onClick={event => {
        if (isBYO) {
          event.preventDefault();
          const sofaBuilderLink = getSofaBuilderLink(byoCollectionName, urlKey);

          if (isExternalLink(sofaBuilderLink)) {
            window.open(sofaBuilderLink);
          } else {
            // force reload modular page to handle marxent performance issues
            // https://stitchindustries.atlassian.net/browse/CON-6483
            window.location.href = sofaBuilderLink;
          }
        }
      }}
    >
      <div
        className={cx(
          'relative flex w-full justify-between border h-20 p-4 mt-3 text-gray rounded-sm hover:border-gray-light2 hover:transition-border hover:duration-300',
          {
            'border-gray-dark': isActive,
            'border-gray-light6': !isActive,
            'normal-case': isBYO,
          }
        )}
      >
        {isActive && (
          <div className="flex justify-center items-center bg-gray-dark h-4 w-4 absolute rounded-sm top-0 right-0 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg>path]:fill-white [&>svg>path]:stroke-white">
            <IconCheck />
          </div>
        )}
        <div className="flex">
          <div className="flex justify-center items-center [&>svg]:w-14 h-12 w-14 mr-2">
            {!isBYO && image ? (
              <JBImage src={image} width={56} />
            ) : (
              <IconFourSquare />
            )}
          </div>
          <div className="flex flex-col ml-1">
            <div className="text-sm font-bold">{name}</div>
            <div className="text-xs text-gray-light2 lowercase">
              {dimensions}
            </div>
          </div>
        </div>
        <div className="flex">
          {!isBYO ? (
            <div className="font-bold text-sm">
              {' '}
              <Currency>{price}</Currency>
            </div>
          ) : null}
        </div>
      </div>
    </Link>
  );
};

PDPAvailableInSizesListItem.propTypes = {
  byoCollectionName: PropTypes.string,
  dimensions: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  image: PropTypes.string,
  isActive: PropTypes.bool,
  isBYO: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  urlKey: PropTypes.string,
  productsData: PropTypes.arrayOf(PropTypes.object),
};

export default PDPAvailableInSizesListItem;
